import { BrandProfile, OrganizerProfile } from '../types/profile'
import { Collaboration } from '../types/collaboration'

export const seedDemoData = () => {
  // Demo Brands
  const demoBrands: BrandProfile[] = [
    {
      id: 'brand-kex-1',
      userId: 'user-kex-1',
      companyName: 'KEXChoklad AB',
      contactName: 'Anna Bergström',
      contactTitle: 'Marketing Director',
      email: 'anna@kexchoklad.se',
      phone: '+46 70 123 4567',
      website: 'https://kexchoklad.se',
      industry: 'Food & Beverage',
      description: 'Premium Swedish chocolate wafer brand loved by all ages',
      marketingGoals: 'Brand Awareness,Product Sampling,Community Engagement',
      targetAgeGroups: [
        'Gen Z (18-24)',
        'Millennials (25-40)',
        'Gen X (41-56)',
      ],
      targetAudienceTypes: ['Students', 'Professionals', 'Families'],
      activationRegions: ['Stockholm', 'Gothenburg', 'Nationwide'],
      sponsorshipType: ['In-Kind Product', 'Merchandise'],
      productsForSampling: [
        'KEX Original',
        'KEX Dark Chocolate',
        'KEX Mini Packs',
      ],
      budgetRange: '50,000 - 100,000 SEK',
      preferredEventCategories: ['Festivals', 'Community', 'Sports'],
      avoidCategories: ['Alcohol-focused'],
      productName: 'KEX Chocolate Wafers',
      productDescription: 'Classic Swedish chocolate wafer snack',
      createdAt: new Date('2024-01-15'),
    },
    {
      id: 'brand-burger-1',
      userId: 'user-burger-1',
      companyName: 'BurgerWave',
      contactName: 'Erik Johansson',
      contactTitle: 'Brand Manager',
      email: 'erik@burgerwave.se',
      phone: '+46 70 234 5678',
      website: 'https://burgerwave.se',
      industry: 'Food & Beverage',
      description: 'Modern burger chain with plant-based and premium options',
      marketingGoals: 'Product Sampling,Lead Generation,Sales',
      targetAgeGroups: ['Gen Z (18-24)', 'Millennials (25-40)'],
      targetAudienceTypes: ['Students', 'Young Professionals', 'Foodies'],
      activationRegions: ['Stockholm', 'Malmö', 'Uppsala'],
      sponsorshipType: ['Financial', 'In-Kind Product'],
      productsForSampling: [
        'Signature Burger Samples',
        'Plant-Based Options',
        'Fries & Drinks',
      ],
      budgetRange: '100,000 - 250,000 SEK',
      preferredEventCategories: [
        'Music Festival',
        'Food Festival',
        'Sports Event',
      ],
      avoidCategories: [],
      productName: 'BurgerWave Menu Items',
      productDescription: 'Premium burgers and sides',
      createdAt: new Date('2024-01-20'),
    },
  ]

  // Demo Organizers/Events
  const demoOrganizers: OrganizerProfile[] = [
    {
      id: 'org-slussen-1',
      userId: 'user-slussen-1',
      organizerName: 'Slussen Events AB',
      contactName: 'Maria Andersson',
      email: 'maria@slussensummer.se',
      phone: '+46 70 345 6789',
      website: 'https://slussensummerfest.se',
      eventName: 'Slussen Summer Fest',
      description: 'Annual summer music and food festival in central Stockholm',
      eventType: 'Music Festival',
      elevatorPitch:
        "Stockholm's premier summer festival with 5,000+ attendees",
      eventFrequency: 'Annual',
      eventDate: '2024-07-15',
      location: 'Slussen, Stockholm',
      attendeeCount: '5,000+',
      audienceTypes: [
        'Students',
        'Young Professionals',
        'Music Lovers',
        'Foodies',
      ],
      audienceAgeGroups: ['Gen Z (18-24)', 'Millennials (25-40)'],
      audienceDescription: 'Young, urban, music and food enthusiasts',
      desiredSponsorCategories: ['Food & Beverage', 'Entertainment', 'Tech'],
      sponsorOfferings: [
        'Logo Placement',
        'Booth Space',
        'Product Sampling',
        'Social Media Mentions',
      ],
      sponsorshipFeatures: [
        'Logo on stage',
        'Booth space',
        'Sampling area',
        'Social media',
      ],
      socialMediaLinks: ['@slussensummerfest', 'facebook.com/slussensummer'],
      digitalReach: '50,000-100,000',
      pressCoverage: 'Yes',
      activationSpace: 'Large (20x20+)',
      audienceDemographics: ['18-24', '25-34'],
      offeringTypes: [
        'brand_visibility',
        'product_sampling',
        'content_creation',
      ],
      createdAt: new Date('2024-01-10'),
    },
    {
      id: 'org-brunnsviken-1',
      userId: 'user-brunnsviken-1',
      organizerName: 'Brunnsviken Events',
      contactName: 'Lars Svensson',
      email: 'lars@brunnsvikeneco.se',
      phone: '+46 70 456 7890',
      website: 'https://brunnsvikenecofair.se',
      eventName: 'Brunnsviken Eco Fair',
      description:
        'Sustainability-focused community fair with eco-conscious brands',
      eventType: 'Community Fair',
      elevatorPitch:
        'Leading eco-fair promoting sustainable living and green products',
      eventFrequency: 'Bi-annual',
      eventDate: '2024-06-20',
      location: 'Brunnsviken, Stockholm',
      attendeeCount: '1,000 - 5,000',
      audienceTypes: [
        'Families',
        'Eco-Conscious',
        'Health Conscious',
        'Local Community',
      ],
      audienceAgeGroups: ['Millennials (25-40)', 'Gen X (41-56)'],
      audienceDescription:
        'Environmentally conscious families and professionals',
      desiredSponsorCategories: [
        'Food & Beverage',
        'Health & Wellness',
        'Sustainable Products',
      ],
      sponsorOfferings: [
        'Logo Placement',
        'Booth Space',
        'Product Sampling',
        'Workshop Space',
      ],
      sponsorshipFeatures: [
        'Eco-friendly booth',
        'Sampling stations',
        'Workshop hosting',
      ],
      socialMediaLinks: ['@brunnsvikeneco', 'instagram.com/brunnsvikenecofair'],
      digitalReach: '10,000-50,000',
      pressCoverage: 'Occasional',
      activationSpace: 'Medium (10x10)',
      audienceDemographics: ['25-34', '35-44', '45-54'],
      offeringTypes: [
        'brand_visibility',
        'product_sampling',
        'lead_generation',
      ],
      createdAt: new Date('2024-01-12'),
    },
  ]

  // Demo Partnerships
  const demoPartnerships: Collaboration[] = [
    {
      id: 'collab-kex-slussen',
      title: '10,000 KEXChoklad Drops at Slussen Summer Fest',
      type: 'product_sampling',
      brandName: 'KEXChoklad AB',
      organizerName: 'Slussen Summer Fest',
      description:
        'KEXChoklad distributed 10,000 chocolate wafer samples at Slussen Summer Fest, creating memorable brand moments with festival-goers through interactive sampling stations and photo opportunities.',
      imageUrl:
        'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=800&h=500&fit=crop',
      metrics: {
        attendees: '5,000+',
        samples: '10,000',
        leads: '1,200+',
        socialReach: '75,000+',
      },
      saved: false,
    },
    {
      id: 'collab-burger-brunnsviken',
      title: 'BurgerWave Pop-Up at Brunnsviken Eco Fair',
      type: 'event_sponsorship',
      brandName: 'BurgerWave',
      organizerName: 'Brunnsviken Eco Fair',
      description:
        'BurgerWave showcased their plant-based burger line at Brunnsviken Eco Fair with a pop-up sampling station, reaching eco-conscious consumers and generating significant interest in sustainable dining.',
      imageUrl:
        'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=500&fit=crop',
      metrics: {
        attendees: '3,200',
        samples: '800 burgers',
        leads: '450+',
        socialReach: '35,000+',
      },
      saved: false,
    },
  ]

  // Demo Messages (for testing notifications)
  const demoMessages = [
    {
      id: 'msg-1',
      partnershipId: 'collab-kex-slussen',
      senderId: 'user-slussen-1',
      senderName: 'Maria Andersson',
      receiverId: 'user-kex-1',
      message:
        "Hi! We'd love to discuss sampling opportunities for Slussen Summer Fest. Are you available for a call this week?",
      timestamp: new Date('2024-01-25T10:30:00'),
      read: false,
    },
  ]

  // Save to localStorage
  localStorage.setItem('brands', JSON.stringify(demoBrands))
  localStorage.setItem('organizers', JSON.stringify(demoOrganizers))
  localStorage.setItem('collaborations', JSON.stringify(demoPartnerships))
  localStorage.setItem('messages', JSON.stringify(demoMessages))

  console.log('✅ Demo data seeded successfully')
  console.log('📊 Brands:', demoBrands.length)
  console.log('📊 Organizers:', demoOrganizers.length)
  console.log('📊 Partnerships:', demoPartnerships.length)
  console.log('📊 Messages:', demoMessages.length)
}

// Initialize demo data on app load
export const initializeDemoData = () => {
  const hasData =
    localStorage.getItem('brands') && localStorage.getItem('organizers')

  if (!hasData) {
    seedDemoData()
  }
}
